import { LevelEntity } from 'shared/domain/level/types/entity';
import { SiteEntity } from 'shared/domain/site/types/entity';
import { debugLog } from 'shared/logger/debugLog';

export const createDocumentationSitesAndLevelsMap = (
  sites: SiteEntity[],
  levels: LevelEntity[]
): {
  docSitesMap: Map<string, SiteEntity[]>;
  docLevelsMap: Map<string, LevelEntity[]>;
} => {
  const docSitesMap = new Map<string, SiteEntity[]>();
  const docLevelsMap = new Map<string, LevelEntity[]>();

  levels.forEach((level) => {
    const documentationId = level.map?.documentationId;
    if (!documentationId) {
      return;
    }

    const site = sites.find((s) => s._id === level.site);
    if (!site) {
      debugLog(
        'createDocumentationSitesAndLevelsMap: Site not found for siteId:',
        level.site
      );
      return;
    }

    const existingSites = docSitesMap.get(documentationId) || [];
    if (!existingSites.includes(site)) {
      existingSites.push(site);
      docSitesMap.set(documentationId, existingSites);
    }
    docLevelsMap.set(documentationId, [...(docLevelsMap.get(documentationId) || []), level]);
  });

  return { docSitesMap, docLevelsMap };
};
